import { render, staticRenderFns } from "./editDocument.vue?vue&type=template&id=6d3e8627&scoped=true"
import script from "./editDocument.vue?vue&type=script&lang=js"
export * from "./editDocument.vue?vue&type=script&lang=js"
import style0 from "./editDocument.vue?vue&type=style&index=0&id=6d3e8627&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3e8627",
  null
  
)

export default component.exports